<template>
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.9336 11.3281L18.2422 5.77344C17.9258 5.31641 17.3984 5 16.8359 5H7.37891C6.81641 5 6.28906 5.31641 5.97266 5.77344L2.28125 11.3281C2.07031 11.6094 2 11.9258 2 12.2773V16.8125C2 17.7617 2.73828 18.5 3.6875 18.5H20.5625C21.4766 18.5 22.25 17.7617 22.25 16.8125V12.2773C22.25 11.9258 22.1445 11.6094 21.9336 11.3281ZM7.69531 7.25H16.5195L19.543 11.75H15.2188L14.0938 14H10.1562L9.03125 11.75H4.67188L7.69531 7.25Z"
        />
    </svg>
</template>
